export default __webpack_public_path__ + "static/media/SapphirePokeball.a4d543c3.svg";